import React, {memo} from 'react'
import Carousel from '@cosmos/carousel'
import cx from 'classnames'

/* Components */
import VariantBox from '../box/VariantBox'

/* Actions */
import {actionCreators as productActionCreators} from '../../../../../redux/actions/productActions'
import {actionCreators as modalActionCreators} from '../../../../../redux/actions/modalActions'

/* Utils */
import {resolveWithSettleContext} from '../../../../../common/async/promiseUtils'
import DataSet from '../../../../../utils/DataSet'

/* Constants */
import {MODAL_IDS} from '../../../../../modules/modal/modalConstants'
import {DAVINCI_EVENT_NAMES} from '../../../../../modules/analytics/davinci/davinciConstants'
import {VARIANT_TYPE_NAMES} from '../../../../../modules/product/productDesktopConstants'

/* Styles */
import s from './variant-row.scss'

const VariantRow = memo(({
  dispatch,
  variant,
  activeVariant,
  unAvailableVariants,
  onVariantChange,
  isAvailableProduct,
  brandName,
  sku,
  pageTypeForDavinci,
  isFashionProduct,
  categoryId,
  categoryName,
  productId,
  merchantName,
  merchantId,
  listingId,
  price,
}) => {

  const handleOnClickVariant = (variant) => {
    if (onVariantChange) {
      onVariantChange(variant)
    }
  }

  const handleSizeChart = () => {
    window?.hepsiBus?.track(DAVINCI_EVENT_NAMES.LINK_CLICK, {
      page_type: pageTypeForDavinci,
      page_value: sku,
      location: 'buybox',
      text: 'Beden Tablosu',
      placement: '',
      position: '',
      url: '',
    })
    resolveWithSettleContext(
      dispatch(
        productActionCreators.getSizeChart.trigger({
          brand: brandName,
        }),
      ),
    )
    dispatch(
      modalActionCreators.openModal(MODAL_IDS.SIZE_CHART),
    )
  }

  return (
    <div className={s.root} data-test-id={'variant-row'}>
      <div className={s.variantTitle}>
        <div className={s.variant}>
          <span className={s.propertyName} data-test-id={'variant-name'}>{variant?.name}: </span>
          <span
            className={s.propertyValue}
            data-test-id={'variant-value'}>{activeVariant?.values?.[variant?.name]}</span>
        </div>
        {
          variant?.name === 'Beden' && isFashionProduct &&
          <div
            className={s.variantExtra}
            data-test-id={'size-chart'}
            onClick={() => handleSizeChart()}
            data-hbus={DataSet.createComponentViewDataForDavinci({
              pageType: pageTypeForDavinci,
              pageValue: sku,
              placement: 'buybox',
              component: 'size chart',
              componentOrder: '10',
              componentDetail: 'Beden Tablosu',
              categoryHierarchy: `${categoryId}-${categoryName}`,
              productId: productId,
              merchantName: merchantName,
              merchantId: merchantId,
              listingId: listingId,
              price: `${price}`,
            })}>
            <i className={s.extraIcon}/>
            <span className={s.extraName}>{'Beden Tablosu'}</span>
          </div>
        }
      </div>
      <div>
        <Carousel
          nextArrowClassname={s.nextArrow}
          prevArrowClassname={s.prevArrow}>
          {
            variant?.properties?.map((property) => (
              <div className={cx(s.variantProperties, VARIANT_TYPE_NAMES?.[property?.name])} data-test-id={'variant-properties'}>
                <VariantBox
                  isAvailableProduct={isAvailableProduct}
                  activeVariant={activeVariant}
                  variantType={variant?.variantType}
                  variantShape={variant?.variantShape}
                  isShowPrice={variant?.isShowPrice}
                  isInStock={property?.isInStock}
                  unAvailableVariants={unAvailableVariants}
                  variantName={variant?.name}
                  variant={property}
                  isFashionProduct={isFashionProduct}
                  onClickVariant={handleOnClickVariant}/>
              </div>
            ))
          }
        </Carousel>
      </div>
    </div>
  )
})

export default VariantRow
